import React from 'react'

const UIPath = (
  <div className='md:w-4/5 mx-auto py-10 text-lg'>
    <h1 className='text-2xl font-bold'>
      UI Path
    </h1>
    <br />
    <div className='md:px-5 text-gray-500'>
      UiPath is a robotic process automation platform for end-to-end high-scale
      automation. UiPath software offers solutions for enterprises to automate
      repetitive office tasks for rapid business transformation. It converts boring tasks
      into automation process using multiple tools. It was founded by Romanian
      entrepreneur Daniel Dines in the year 2005.
      More and more companies are adopting Digital day by day. With digitization,
      the biggest advantage is the speed of execution. But the challenge with
      digitization is that it requires diverse tools and hence manpower with diverse
      skillset is required to handle those tools. But workforce having varied skill set is
      scarce.
      <h1 className='text-lg font-bold md:pr-5 mt-6 text-gray-900'>
        Features of UIPath
      </h1>
      <br />
      <div className='md:px-5'>
        <ul className='md:px-5 list-disc pl-5 text-gray-500'>
          <li>
            <span className='font-bold mr-2 text-gray-900'>Hosting Options:</span>
            It can be hosted in cloud environments or virtual
            terminals.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'>Application Compatibility:</span>
            Offers a high range of applications to work
            with, which includes web and desktop applications.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Centralized repository: </span>
            This feature helps for handling all the robots
            simultaneously by users.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Security:</span>
            Offers auto login features to run the bots.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'>Advanced screen scraping solution: </span>
            Scraping solution that works with
            any application like,.Net, Java, Flash, PDF, Legacy, SAP, with absolute
            accuracy.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Reliable tool for modeling business processes: </span>
            The UiPath studio offers
            automation excellence with the help of model business processes.
          </li>
          <br />
          <li>
            <span className='font-bold mr-2 text-gray-900'> Level of scalability and Robustness: </span>
            <ul className='md:px-10 py-5 pl-5 text-gray-500'>
              <li>
                Effective debugging and exception handling mechanisms
              </li>
              <li>
                Artificial intelligence handling day to day applications like
                outlooks excel, PDF.
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <h1 className='text-lg font-bold md:pr-5 mt-6 text-gray-900'>
        UiPath Vs. Other Automation Tools
      </h1>
      <br />
      <div className='md:px-5 text-gray-900'>
        <p>
          We have many automation tools already in the market like Selenium,
          Waite. These software’s or frameworks generally perform best on web
          automation but fail miserably when you try to automate desktop
          applications or any remote applications etc.
        </p>
        <br />
        <p className='font-bold text-gray-900'>Areas, where RPA tools like UiPath surpass existing technology, are:</p>
        <br />
        <ul className='md:px-10 list-disc pl-5 text-gray-500'>
          <li>
            Desktop Automation
          </li>
          <br />
          <li>
            Remote applications
          </li>
          <br />
          <li>
            Data handling techniques
          </li>
          <br />
          <li>
            Scrapping techniques
          </li>
          <br />
          <li>
            The methodology of writing the logics
          </li>
          <br />
        </ul>
      </div>
    </div>
  </div>
)

export default UIPath